import { IState } from "../vuex/IState";
import { IWebApplication } from "@timesheets/webapp-support";
import { Route } from "@gemma/utils";
import { Store } from "vuex";
import { TRouteMetaGroup } from "../routing";
import VueRouter from "vue-router";
import { registerGlobalComponents } from "./registerGlobalComponents";
import { registerSubscriptions } from "./registerSubscriptions";

export function registrations(router: VueRouter, store: Store<IState>, webApplication: IWebApplication<Route<TRouteMetaGroup>>) {
  registerSubscriptions(router, store, webApplication);

  registerGlobalComponents();
}
